"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _isURL = _interopRequireDefault(require("validator/lib/isURL"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const allowedProtocols = ['http', 'https'];
class WebsiteInputValidator {
  validatePattern(value) {
    return (0, _isURL.default)(value, {
      protocols: allowedProtocols
    });
  }
}
const websiteInputValidator = new WebsiteInputValidator();
var _default = exports.default = websiteInputValidator;